import React from 'react';

export default function NotFound() {
  return (
    <section>
      <img style={{ width: '100%' }} alt="404" src="/assets/images/404_page_cover.jpg" />
    </section>
  );
}
